import { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useCart } from "./CartContext";
import { useNavigate } from "react-router-dom";
import { LOCAL_BOOKS } from "./Booksdata";
import toast from "react-hot-toast";
export default function BooksPage() {
  const navigate = useNavigate();
  const { currency, currencySymbol } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const localMap = useMemo(() => {
    const m = new Map();
    LOCAL_BOOKS.forEach((b) => m.set(b.id, b));
    return m;
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, "products"));
        const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setProducts(items);
      } catch (e) {
        console.error("Fetch products error:", e);
        toast.error("Couldn't load books. Please refresh the page.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getPrice = (p) => Number(p?.prices?.[currency]) || 0;

  const books = useMemo(() => {
    return products
      .filter((p) => p.active !== false)
      .map((p) => {
        const local = localMap.get(p.id);
        return {
          ...p,
          images: local?.images || [],
          image: local?.images?.[0] || null,
        };
      });
  }, [products, localMap]);

  if (loading) {
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center gap-4">
      <div className="w-14 h-14 border-4 border-brand border-t-transparent rounded-full animate-spin" />
      <p className="text-brand font-modum tracking-widest text-sm">LOADING BOOKS...</p>
    </div>
  );
}


  return (
    <div className="bg-black">
      <header className="text-center pt-20 pb-12">
        <h1 className="text-9xl font-bold font-modum text-brand">BOOKS</h1>
      </header>
    <div className="bg-white">
      <div className="flex flex-wrap justify-center gap-6 p-8 max-w-6xl mx-auto">
      {books.map((book) => {
        const price = getPrice(book);

        return (

          <div

 key={book.id}
            onClick={() => navigate(`/books/${book.id}`)}
            className="cursor-pointer bg-brand rounded-xl shadow-md hover:scale-105 transition-transform duration-300 overflow-hidden w-64"
          >
            {book.image ? (
              <div className="w-full h-56 bg-white flex items-center justify-center p-2">
                <img
                  src={book.image}
                  alt={book.title}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ) : (
              <div className="w-full h-56 bg-gray-200 flex items-center justify-center">
                No image
              </div>
            )}

            <div className="p-3 text-gray-800">
              <h2 className="font-semibold text-sm mb-1 line-clamp-2">{book.title}</h2>
              <p className="text-gray-700 text-sm font-medium">
                {currencySymbol} {price ? price.toFixed(2) : "—"}
              </p>
            </div>
           
          
          </div>
          
        );
      })}
    </div>
    </div>
    </div>
  );
}
